import { Directive } from '@angular/core';
import { CdkTreeNode } from '@angular/cdk/tree';

@Directive({
  selector: 'mcrai-tree-node',
  host: {
    'class': 'mcrai-tree-node'
  },
  providers: [{ provide: CdkTreeNode, useExisting: TreeNodeDirective }]
})
export class TreeNodeDirective<T> extends CdkTreeNode<T> { }